import { useThemeContext } from "@/shared/theme/components/theme-provider";

export function useTheme() {
  return useThemeContext();
}
